export enum TransactionEventType {
	CaptureContextError = "CaptureContextError",
	SetupError = "SetupError",
	CheckEnrollmentError = "CheckEnrollmentError",
	PaymentError = "PaymentError",
	VerifyError = "VerifyError",
	ConfirmError = "ConfirmError",
}
